import React from 'react'

const HardDeleteButton = React.memo(({ deleteConversation }) => {
  return (
    <div className="hard-delete">
      <a className="menu-button label danger" onClick={deleteConversation}>
        <span className="label">Delete forever</span>
      </a>
    </div>
  )
})

export default HardDeleteButton
